import { TabButton } from '@components/button/TabButton';
import { mdiAngleAcute, mdiSelectGroup } from '@mdi/js';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslations } from '@services/hooks/translations/useTranslations';
import React from 'react';
import { Patch } from '../../roofVisualisationTypes';
import { getNumberOfSelectedPanels, useSelectedPatchAngleValue } from '../utils';
import {
  useHandleSelectGroup,
  useHandleSelectPatch,
} from '../../utils/useSolarMapVisualisation/mapControlAndCallbackFunctions/navigation';

export type SelectionPanelsStateButtonsProps = {
  disableButtons: boolean;
  patches: Patch[];
  shouldSelectPatch: boolean;
};

export const SelectionPanelsStateButtons: React.FC<SelectionPanelsStateButtonsProps> = ({
  disableButtons,
  patches,
  shouldSelectPatch,
}) => {
  const {
    translate,
    translations: {
      leads: {
        details: {
          project: {
            addEditPage: {
              solarEnergy: { panelSettingsHeader },
            },
          },
        },
      },
    },
  } = useTranslations();

  const handleSelectPatch = useHandleSelectPatch();
  const handleSelectGroup = useHandleSelectGroup();

  const angle = useSelectedPatchAngleValue();

  return (
    <Stack spacing={3} marginBlockEnd={1}>
      <Typography variant="h2">{translate(panelSettingsHeader)}</Typography>
      <Stack direction="row">
        {patches.map(({ id, selected, panels }) => (
          <TabButton
            key={id}
            icon={mdiSelectGroup}
            alt="Edit patch"
            selected={selected}
            onClick={shouldSelectPatch ? handleSelectPatch(id) : undefined}
            title={getNumberOfSelectedPanels(panels)}
            buttonType="secondary"
            disabled={disableButtons}
          />
        ))}
        <TabButton
          icon={mdiAngleAcute}
          alt="Select group"
          onClick={handleSelectGroup}
          disabled={disableButtons}
          buttonType="secondary"
          title={angle}
        />
      </Stack>
    </Stack>
  );
};
